/**
 * Loader komponenta, která umožňuje zobrazit indikátor načítání
 * a ovládat jeho viditelnost pomocí JavaScriptu.
 */
export default class Loader {
    private static instance: Loader | null = null;
    private element: HTMLElement | null = null;

    /**
     * Inicializace loaderu - vytvoření HTML elementu a přidání do DOM
     */
    static init(): void {
        if (!this.instance) {
            this.instance = new Loader();
            this.instance.createLoader();
            this.hide(); // Defaultně je loader skrytý
        }
    }

    /**
     * Vytvoření HTML struktury loaderu
     */
    private createLoader(): void {
        // Kontrola, zda loader již neexistuje
        if (document.querySelector('.loader')) {
            this.element = document.querySelector('.loader');
            return;
        }

        // Vytvoření HTML elementů
        this.element = document.createElement('div');
        this.element.className = 'loader loader--hidden';

        const spinner = document.createElement('div');
        spinner.className = 'loader__spinner';

        const dots = document.createElement('div');
        dots.className = 'loader__dots';

        // Vytvoření teček
        for (let i = 0; i < 3; i++) {
            const span = document.createElement('span');
            dots.appendChild(span);
        }

        // Vložení spinneru a teček do loaderu
        this.element.appendChild(spinner);
        this.element.appendChild(dots);

        // Přidání loaderu do body
        document.body.appendChild(this.element);
    }

    /**
     * Zobrazí loader
     */
    static show(): void {
        if (this.instance && this.instance.element) {
            this.instance.element.classList.remove('loader--hidden');
        }
    }

    /**
     * Skryje loader
     */
    static hide(): void {
        if (this.instance && this.instance.element) {
            this.instance.element.classList.add('loader--hidden');
        }
    }

    /**
     * Přepne stav loaderu (zobrazí/skryje)
     */
    static toggle(): void {
        if (this.instance && this.instance.element) {
            this.instance.element.classList.toggle('loader--hidden');
        }
    }

    /**
     * Zobrazí loader na určitý čas a poté ho skryje
     * @param duration Doba v milisekundách, po kterou je loader zobrazen
     */
    static showFor(duration: number): void {
        this.show();
        setTimeout(() => {
            this.hide();
        }, duration);
    }

    /**
     * Zruší a odstraní loader z DOM
     */
    static destroy(): void {
        if (this.instance && this.instance.element) {
            this.instance.element.remove();
            this.instance = null;
        }
    }
}
